import React from 'react';
import classnames from 'classnames';

import Icon from 'components/Misc/Icon';

const Alert = ({ theme, icon, message, className }) => {
	const cls = classnames(
		'py-3 px-4 flex items-center space-x-3 rounded-lg',
		theme === 'warning' && 'bg-amber-500 text-white',
		theme === 'danger' && 'bg-rose-500 text-white',
		className
	);

	return (
		<div className={cls}>
			<Icon icon={icon} className="text-3xl" />
			
			<div>
				{message}
			</div>
		</div>
	);
};

export default Alert;